import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterModule } from '@angular/router';
import { filter, take } from 'rxjs';
import { UpdateNotification } from './shared/components/ui/updateNotification/updateNotification';
import { Toast } from './shared/components/ui/toast/toast';
import { LoadingSpinner } from './shared/components/ui/loadingSpinner/loadingSpinner';
import { GlobalModalService } from './shared/components/ui/modalService/globalModalService';
import { GlobalLoadingStore } from './shared/components/ui/loadingSpinner/global-loading.store';
import { AuthService } from './shared/services/auth/auth.service';
import { Onboarding } from './features/auth/onboarding/onboarding';
import { NotificationPrompt } from './features/settings/pushNotification/notificationPrompt/notification-prompt';
import { RfidScannerService } from './shared/services/rfid/rfidscanner.service';
import { changelogStore } from './shared/services/changelog/changelog.store';


@Component({
  imports: [
    RouterModule,
    UpdateNotification,
    Toast,
    LoadingSpinner,
    GlobalModalService,
    Onboarding,
    NotificationPrompt,
  ],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected title = 'schafzucht_2025';
  protected readonly auth = inject(AuthService);
  readonly rfidScanner = inject(RfidScannerService);
  private readonly changelogStore = inject(changelogStore);
  private readonly loadingStore = inject(GlobalLoadingStore);
  private readonly router = inject(Router);

  constructor() {
    this.rfidScanner.init();

    // Guard-Auflösung (Keycloak-Check, Onboarding-/Health-Check) läuft sonst unsichtbar ab
    // und hinterlässt bis zur ersten Routenaktivierung eine leere Seite ohne Spinner.
    this.loadingStore.start();
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError),
        take(1),
      )
      .subscribe(() => {
        this.loadingStore.stop();
        this.rfidScanner.claimFocus();
      });
  }
}
